import { getPuzzle } from '@wt/app/game/_utils/getPuzzle';
import md5 from 'md5';
import { useCallback, useEffect, useState } from 'react';

import {
  Guess,
  loadAllGuesses,
  saveGuesses,
  saveHints,
} from '../_components/types';
import { GameMode } from '@wt/game/utils/types';

export function usePuzzleTodays(
  puzzleId: string,
  gameLength: number,
  gameMode: GameMode
): [
  {
    guesses?: Guess[];
  },
  (guess: Guess) => void,
] {
  const [todays, setTodays] = useState<{
    guesses?: Guess[];
  }>({ guesses: undefined });

  const addGuess = useCallback(
    (newGuess: Guess) => {
      if (todays == null) {
        return;
      }

      const newGuesses = todays.guesses
        ? [...todays.guesses, newGuess]
        : [newGuess];

      setTodays(() => ({ guesses: newGuesses }));
      saveGuesses(puzzleId, gameLength, newGuesses, gameMode);
      saveHints(newGuess, gameMode);
    },
    [puzzleId, todays]
  );

  useEffect(() => {
    const allGuesses = loadAllGuesses(gameMode);

    let guesses = allGuesses[puzzleId] ?? [];
    guesses = guesses.map((g) => {
      if (g.puzzle.url.indexOf('cdn.whentaken.com') === -1) {
        g.puzzle.url =
          'https://cdn.whentaken.com/images/' + md5(g.puzzle.url) + '.jpg';
      }
      return g;
    });
    getPuzzle(puzzleId, gameMode).then((p) => {
      if (!p || p.length < 1) {
        return;
      }
      const tmpGuesses = guesses.map((g, gi) => {
        const puzzle = p[gi] ?? g.puzzle;
        if (puzzle) {
          return { ...g, puzzle };
        }
        return g;
      });
      setTodays({ guesses: tmpGuesses });
    });
  }, [puzzleId]);

  return [todays, addGuess];
}
